import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "attrs"];
import React from 'react';
import classnames from 'classnames';

const renderBy = status => node => {
  return status ? node : null;
};

const Text = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    icon,
    text
  } = attrs;
  const unHealth = !window.location.host.includes('ihealth');
  const cls = classnames({
    'components-result-text-render': true,
    'no-logo': unHealth,
    [className]: !!className
  });
  const titleNode = renderBy(text)( /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, text));
  const imgNode = renderBy(icon)( /*#__PURE__*/React.createElement("div", {
    className: "img-container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: "img",
    src: icon
  })));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), titleNode, imgNode);
});
export default Text;